import * as XLSX from 'xlsx';

import { linhasDaPlanilha } from './fila-ecoa';

type LinhaDaPlanilha = ReturnType<typeof linhasDaPlanilha>[number];

/** Colunas de ECN-53, para o cabeçalho sair mesmo com a lista vazia. */
const COLUNAS: (keyof LinhaDaPlanilha)[] = [
  'Ação',
  'Cadastrada por',
  'Chave',
  'Eixo',
  'Período',
  'Integrantes',
  'Status',
  'Pontos',
  'Feedback',
  'Cadastro',
  'Atualização',
];

export function nomeDoArquivo(ciclo: string, fase: string): string {
  return `acoes-ecoa-${ciclo}-${fase}.xlsx`;
}

/** ECN-53: gera e baixa a planilha da lista exibida; erro de escrita propaga para a tela. */
export function exportarAcoesEcoa(linhas: LinhaDaPlanilha[], ciclo: string, fase: string): void {
  const planilha = XLSX.utils.json_to_sheet(linhas, { header: COLUNAS as string[] });
  const arquivo = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(arquivo, planilha, 'Ações ECOA');
  XLSX.writeFile(arquivo, nomeDoArquivo(ciclo, fase));
}
